import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../../services/WiMuleSQL";

export const useGetOrdersStatus = (fromDateTime, toDateTime) => {
  // Helper function to ensure the fromDate starts at 00:00:01
  const formatFromDate = (date) => {
    date.setHours(0, 0, 0); // Use 00:00:00 instead of 00:00:01
    return date.toISOString().split(".")[0];
  };

  // Helper function to ensure the toDate ends at 23:59:59
  const formatToDate = (date) => {
    date.setHours(23, 59, 59);
    return date.toISOString().split(".")[0];
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate); // Clone the input date
    return date.toISOString().split("T")[0]; // Extract only the date portion (YYYY-MM-DD)
  };

  const fetchData = async () => {
    const queryString = `${WiMuleSQL}/api/WiTool/GetServerOrders?fromDate=${formatFromDate(
      fromDateTime
    )}&toDate=${formatToDate(toDateTime)}`;
    const response = await fetch(queryString, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return response.json();
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getOrdersStatus", fromDateTime, toDateTime],
    queryFn: fetchData,
    // The query should be enabled only if both fromDateTime and toDateTime are provided
    enabled: !!fromDateTime && !!toDateTime,
    refetchInterval: () =>
      document.visibilityState === "visible" ? 60000 : 600000, // 1 min in focus, 10 min in background
    refetchIntervalInBackground: true, // Ensure background refetching
    refetchOnWindowFocus: true, // Immediate refetch on focus
  });

  return { data, isLoading, isError, error };
};
